"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckPhoneNumberResponseTypeEnum = exports.CheckPhoneNumberResponseToJSON = exports.CheckPhoneNumberResponseFromJSONTyped = exports.CheckPhoneNumberResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function CheckPhoneNumberResponseFromJSON(json) {
    return CheckPhoneNumberResponseFromJSONTyped(json, false);
}
exports.CheckPhoneNumberResponseFromJSON = CheckPhoneNumberResponseFromJSON;
function CheckPhoneNumberResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'normalized': !(0, runtime_1.exists)(json, 'normalized') ? undefined : json['normalized'],
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : json['type'],
        'errors': !(0, runtime_1.exists)(json, 'errors') ? undefined : (0, _1.MessagesFromJSON)(json['errors']),
        'warnings': !(0, runtime_1.exists)(json, 'warnings') ? undefined : (0, _1.MessagesFromJSON)(json['warnings']),
    };
}
exports.CheckPhoneNumberResponseFromJSONTyped = CheckPhoneNumberResponseFromJSONTyped;
function CheckPhoneNumberResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'normalized': value.normalized,
        'type': value.type,
        'errors': (0, _1.MessagesToJSON)(value.errors),
        'warnings': (0, _1.MessagesToJSON)(value.warnings),
    };
}
exports.CheckPhoneNumberResponseToJSON = CheckPhoneNumberResponseToJSON;
/**
* @export
* @enum {string}
*/
var CheckPhoneNumberResponseTypeEnum;
(function (CheckPhoneNumberResponseTypeEnum) {
    CheckPhoneNumberResponseTypeEnum["MOBILE"] = "MOBILE";
    CheckPhoneNumberResponseTypeEnum["FIXED"] = "FIXED";
    CheckPhoneNumberResponseTypeEnum["PERSONAL"] = "PERSONAL";
    CheckPhoneNumberResponseTypeEnum["TOLLFREE"] = "TOLLFREE";
})(CheckPhoneNumberResponseTypeEnum = exports.CheckPhoneNumberResponseTypeEnum || (exports.CheckPhoneNumberResponseTypeEnum = {}));
//# sourceMappingURL=CheckPhoneNumberResponse.js.map